import { render, staticRenderFns } from "./PortfolioMasonry.vue?vue&type=template&id=2ebaf354&"
import script from "./PortfolioMasonry.vue?vue&type=script&lang=js&"
export * from "./PortfolioMasonry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports